import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Play } from 'react-jplayer';
import classNames from 'classnames';
import PlayIcon from '../../../images/vector/play.svg';
import PauseIcon from '../../../images/vector/pause.svg';
import RepeatIcon from '../../../images/vector/repeat.svg';
import { TRO_PLAYLIST, CONTROL_TYPE } from './demoVideoConstants';

const { READING_BOOKS } = TRO_PLAYLIST;
const { PLAY, PAUSE, REPEAT } = CONTROL_TYPE;

const CONTROLS = {
    [PLAY]: <PlayIcon aria-label="Icon for playing the video" role="img" id="play-icon" />,
    [PAUSE]: <PauseIcon aria-label="Icon for pausing the video" role="img" id="pause-icon" />,
    [REPEAT]: <RepeatIcon aria-label="Icon for repeating the video" role="img" id="repeat-icon" />,
};

class PlayerControl extends Component {
    constructor(props) {
        super(props);

        this.onRepeat = this.onRepeat.bind(this);
    }

    onRepeat = () => this.props.playPlaylist(READING_BOOKS.INDEX);

    render() {
        const { show, type, large, pulsating } = this.props;

        return type === REPEAT ? (
            <button
                aria-label="Repeat"
                className={classNames('player-control-btn', type, { show, large })}
                onClick={this.onRepeat}
            >
                {CONTROLS[type]}
                {large && <span className="circle" />}
            </button>
        ) : (
            <div className={classNames('player-control-btn-wrapper', { pulsating })}>
                <Play
                    className={classNames('player-control-btn', type, { show, large })}
                    aria-label="Play video"
                >
                    {CONTROLS[type]}
                    {large && <span className="circle" />}
                </Play>
            </div>
        );
    }
}

PlayerControl.propTypes = {
    show: PropTypes.bool,
    large: PropTypes.bool,
    pulsating: PropTypes.bool,
    playPlaylist: PropTypes.func,
    type: PropTypes.oneOf([...Object.values(CONTROL_TYPE)]),
};

PlayerControl.defaultProps = {
    show: true,
    large: false,
    pulsating: false,
    playPlaylist: () => {},
    type: PLAY,
};

export default PlayerControl;
